
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class TotalCounter extends Vue {
    @Prop({ type: Number, required: true }) readonly total!: number;
     @Prop({ type: String, required: false }) readonly pageName!: string;
  }
